<template>
  <main>
    <div class="info" v-for="item in parkMsg" :key="item.index">
      <div class="title">
        <h3>{{item.title}}</h3>
        <p>{{item.updateTime}}</p>
      </div>
      <div class="content">
        <p>{{item.message}}</p>
      </div>
    </div>
    <div id="div1">
      <van-empty description="暂无信息" />
    </div>
    
    <tabbar current="3"></tabbar>
  </main>
</template>

<script>
    import tabbar from '../components/Tabbar.vue'
    import API from "../api/index"

    export default {
        name: "msg",
        components: {tabbar},

        data () {
          return {
            parkMsg: [],
          }
        },

        mounted() {
          var _this=this;
          this.$http({
          method:'get',
          data: {
          },
          url:API.parkMsg_url
              }).then(function(resp){
                 console.log(resp.data);
                if(resp.data.returnCode == "SUCCESS" && resp.data.data.size() >0) {
                  document.getElementById("div1").style.display="none";
                }
                  console.log(resp.data);
                   _this.parkMsg=resp.data.data;
                }).catch(resp => {
                  console.log('请求失败：'+resp.status+','+resp.statusText);
          });
        },
    }
</script>

<style scoped>
  .info {
    margin: 20px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    padding: 0 20px;
    border-radius: 10px;
  }

  .info .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }

  .info .title h3 {
    color: #333;
    font-size: 32px;
    font-weight: bold;
  }

  .info .title p {
    color: #999;
    font-size: 26px;
  }

  .info .price h3 {
    color: #666;
    text-align: center;
    font-size: 22px;
  }

  .info .price p {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: #ff0000;
    margin-top: 10px;
  }

  .info .price p i {
    font-size: 50px;
    line-height: 50px;
  }

  .info .content {
    padding: 20px 0;
  }

  .info .content p {
    color: #333;
    font-size: 26px;
  }

  /deep/.van-empty {
    margin-top: 100px;
  }

  /deep/.van-empty .van-empty__image {
    width: 500px;
    height: 500px;
  }

  /deep/.van-empty .van-empty__description {
    font-size: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/msg.vue